import React from "react";
import { Link } from "react-router-dom";
import { Github, Mail, MessageCircle, Instagram } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/10 bg-void/60 relative z-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2">
            <div className="font-heading text-2xl font-black">
              NOX<span className="gradient-text">AI</span>
            </div>
            <p className="text-slate-400 text-sm mt-3 max-w-md leading-relaxed">
              Portal berita AI &amp; Robotics dengan katalog repository AI Agent open-source. Didirikan Desember 2023 oleh NOXAI Creation.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="https://www.instagram.com/muse_nox/" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-card border border-white/10 flex items-center justify-center hover:border-cyan1/50 hover:text-cyan1 transition" data-testid="social-instagram">
                <Instagram className="w-4 h-4" />
              </a>
              <a href="https://discord.gg/t7VSFgpVE4" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-card border border-white/10 flex items-center justify-center hover:border-magenta1/50 hover:text-magenta1 transition" data-testid="social-discord">
                <MessageCircle className="w-4 h-4" />
              </a>
              <a href="mailto:noxaicreation@gmail.com" className="w-10 h-10 rounded-full bg-card border border-white/10 flex items-center justify-center hover:border-cyan1/50 hover:text-cyan1 transition" data-testid="social-email">
                <Mail className="w-4 h-4" />
              </a>
              <a href="https://github.com" target="_blank" rel="noreferrer" className="w-10 h-10 rounded-full bg-card border border-white/10 flex items-center justify-center hover:border-cyan1/50 hover:text-cyan1 transition" data-testid="social-github">
                <Github className="w-4 h-4" />
              </a>
            </div>
          </div>
          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-cyan1 mb-4">Jelajahi</div>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/articles" className="hover:text-cyan1">Berita AI</Link></li>
              <li><Link to="/articles?category=Robotics" className="hover:text-cyan1">Robotics</Link></li>
              <li><Link to="/repositories" className="hover:text-cyan1">Agent Catalog</Link></li>
              <li><Link to="/about" className="hover:text-cyan1">About</Link></li>
            </ul>
          </div>
          <div>
            <div className="font-mono text-xs uppercase tracking-widest text-magenta1 mb-4">Repository</div>
            <ul className="space-y-2 text-sm text-slate-300">
              <li><Link to="/repositories?category=LLM Runner" className="hover:text-magenta1">LLM Runners</Link></li>
              <li><Link to="/repositories?category=Framework" className="hover:text-magenta1">Frameworks</Link></li>
              <li><Link to="/repositories?category=Autonomous Agent" className="hover:text-magenta1">Autonomous</Link></li>
              <li><Link to="/repositories?category=MCP" className="hover:text-magenta1">MCP Servers</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/5 text-xs text-slate-500 font-mono flex flex-col md:flex-row justify-between items-center gap-2">
          <div>&copy; 2026 NOXAI CREATION · All rights reserved</div>
          <div>Built with cyan & magenta on port 8001</div>
        </div>
      </div>
    </footer>
  );
}
